import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';
import { hideActiveModal, openActiveModal } from './ratingForm';

class RequestLogin extends PureComponent {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidMount() {
    openActiveModal('contactModal');
    setTimeout(() => window.addEventListener('click', this.clickHandler), 500);
  }

  componentWillUnmount() {
    hideActiveModal(this.props);
    window.removeEventListener('click', this.clickHandler);
  }

  clickHandler({ target }) {
    if (document.getElementsByClassName('modal-content')[0].contains(target)) {
      //Nothing needs to be done
    } else {
      hideActiveModal(this.props);
    }
  }

  render() {
    return (<div className="modal text-center" id="contactModal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <h5>You must log in before continuing.</h5>
            <span className="link mr-3" onClick={() => { hideActiveModal(this.props) }}>Cancel</span>
            <Link to={`/login?redirect=${window.location.hash.substr(1)}`} onClick={() => { hideActiveModal(this.props) }}>Go to Login</Link>
          </div>
        </div>
      </div>
    </div>)
  }
}

export default withRouter(RequestLogin);
